import './App.css';
import { Suspense } from 'react';
import {BrowserRouter,Routes,Route} from "react-router-dom";
import { lazy } from 'react';
import { CanvasProvider } from './Pages/globals';
const Index = lazy(() => import("./Pages"));
const Drawing = lazy(() => import("./DrawApp/drawing"));

function App() {
  return (
    <CanvasProvider>
      <BrowserRouter>
          <Suspense fallback={<p>Cargando...</p>}>
            <Routes>
              <Route path="/">
                  <Route index element={<Index />} />
                  <Route path="draw"  element={<Drawing />} />
                  {/*<Route index element={<Drawing />} />*/}
              </Route>
            </Routes>
          </Suspense>
          </BrowserRouter>
        </CanvasProvider>
  );
}

export default App;
